import React from "react";
import PageShell from "./PageShell";
import KpiBar from "./KpiBar";

/**
 * Template B — Management (PDR §6.B)
 * ──────────────────────────────────
 * Purpose : CRUD a resource collection (Orgs · Staff · Providers · Identity · Directory).
 * Slots   : header, kpis (3-4), filterBar (search + chips + right-slot),
 *           table (<DataTable/>), drawerOrModal (create/edit surface).
 */
export default function TemplateManagement({
  header, kpis, filterBar, table, drawerOrModal, testId = "tpl-management",
}) {
  return (
    <PageShell testId={testId}>
      {header}
      {kpis && (kpis.items ? <KpiBar items={kpis.items} cols={kpis.cols ?? 4} /> : kpis)}
      {filterBar && <div className="tpl-filterbar" data-testid="tpl-filterbar">{filterBar}</div>}
      {table}
      {drawerOrModal}
    </PageShell>
  );
}
